import { SAVE_ORDER_FEE } from '../../actions/constants'

const initialToastState = {
  data: {},
}

const orderFeeReducer = (state = initialToastState, action) => {
  switch (action.type) {
    case SAVE_ORDER_FEE: {
      return { ...state, data: action.data }
    }
    default: {
      return state
    }
  }
}

export default orderFeeReducer
